import { motion } from "framer-motion";
import { Container } from "@/components/ui/Container";
import { Button } from "@/components/ui/Button";
import { fadeInUp } from "@/lib/motion";
import { useLanguage } from "@/components/LanguageContext";

export default function NotFound() {
  const { t } = useLanguage();

  return (
    <div className="min-h-[70vh] flex items-center justify-center bg-warm-white">
      <Container>
        <motion.div 
          variants={fadeInUp}
          initial="hidden"
          animate="visible"
          className="text-center space-y-8"
        >
          <h1 className="text-9xl font-display font-bold text-amber/20">404</h1>
          <div className="-mt-20 relative z-10">
            <h2 className="text-3xl font-display font-bold text-charcoal mb-4">
              {t("Page Non Trouvée", "Page Not Found")}
            </h2>
            <p className="text-graphite max-w-md mx-auto mb-10">
              {t(
                "Désolé, la page que vous recherchez semble ne pas exister ou a été déplacée.",
                "Sorry, the page you are looking for seems not to exist or has been moved."
              )}
            </p>
            <Button href="/" variant="primary" size="lg">
              {t("Retour à l'Accueil", "Back to Home")}
            </Button>
          </div>
        </motion.div>
      </Container>
    </div>
  );
}
